import { LitElement, html } from 'lit';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { customElement, property } from 'lit/decorators.js';

@customElement('product-promotional-messaging')
class ProductPromotionalMessaging extends LitElement {
  @property({ type: String, attribute: 'product-tags' })
  accessor productTags;

  constructor() {
    super();
    this.dataPromo = window.theme.productMessaging;
    this.matchingMessages = [];
  }

  createRenderRoot() {
    return this;
  }

  connectedCallback() {
    super.connectedCallback();
    this.productTags = JSON.parse(decodeURI(this.productTags));
    this._filterPromoMessages();
  }

  _filterPromoMessages = () => {
    const regex = /^comingsoon:.{2,}$/;

    this.matchingMessages = this.dataPromo.filter((item) => {
      const dataPromoTags = item.tag.split(',').map((tag) => tag.trim());

      const containsTags =
        Array.isArray(this.productTags) &&
        this.productTags.some(
          (tag) =>
            dataPromoTags.includes(tag) ||
            (regex.test(tag) &&
              dataPromoTags.some(
                (dataTag) =>
                  dataTag.startsWith('comingsoon:') && dataTag.includes(tag),
              )),
        );
      return containsTags;
    });
  };

  render() {
    if (!this.matchingMessages.length) {
      return null;
    }

    return html`
      <div class="product-promo-messages">
        ${this.matchingMessages.map(
          (messageItem, index) => html`
            <div
              class="body-3 py-[16px]"
              key=${index}
              style="color: ${messageItem.color};"
            >
              ${unsafeHTML(messageItem.message)}
            </div>
          `,
        )}
      </div>
    `;
  }
}

export default ProductPromotionalMessaging;
